export const timer = (seconds: number, setSeconds: (is: number) => void): NodeJS.Timer => {
  const intervalId = setInterval(() => {
    setSeconds(seconds - 1);
  }, 1000);
  return intervalId;
};
